const initialState = {
    isReadingTemplate: false,
    templateBeingUpdated: null,
    templateBeingDeleted: null
}

export default initialState;
